webpackJsonp([111663361672460],{

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/003_sunsmart_home_screen_foo.6248438b.png";

/***/ }),

/***/ 510:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/01_onboarding.fa157112.jpg";

/***/ }),

/***/ 511:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/02_data_entry.fd7315f7.jpg";

/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/03_home_screen_v1.620b644f.jpg";

/***/ }),

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/04_home_screen_v2.32e8ead9.jpg";

/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/05_home_screen_v3.17d0a56d.jpg";

/***/ }),

/***/ 515:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/06_home_screen_v4.a4c06a0b.jpg";

/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/07_sunscreen_calculator.8a53686d.jpg";

/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sunsmart_3d.c59e0495.jpg";

/***/ }),

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sunsmart_promo_high_uv.fe46988a.png";

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactImageGallery = __webpack_require__(27);
	
	var _reactImageGallery2 = _interopRequireDefault(_reactImageGallery);
	
	__webpack_require__(25);
	
	var _sunsmart_3d = __webpack_require__(517);
	
	var _sunsmart_3d2 = _interopRequireDefault(_sunsmart_3d);
	
	var _onboarding = __webpack_require__(510);
	
	var _onboarding2 = _interopRequireDefault(_onboarding);
	
	var _data_entry = __webpack_require__(511);
	
	var _data_entry2 = _interopRequireDefault(_data_entry);
	
	var _home_screen_v = __webpack_require__(512);
	
	var _home_screen_v2 = _interopRequireDefault(_home_screen_v);
	
	var _home_screen_v3 = __webpack_require__(513);
	
	var _home_screen_v4 = _interopRequireDefault(_home_screen_v3);
	
	var _home_screen_v5 = __webpack_require__(514);
	
	var _home_screen_v6 = _interopRequireDefault(_home_screen_v5);
	
	var _home_screen_v7 = __webpack_require__(515);
	
	var _home_screen_v8 = _interopRequireDefault(_home_screen_v7);
	
	var _sunscreen_calculator = __webpack_require__(516);
	
	var _sunscreen_calculator2 = _interopRequireDefault(_sunscreen_calculator);
	
	var _sunsmart_home_screen_foo = __webpack_require__(509);
	
	var _sunsmart_home_screen_foo2 = _interopRequireDefault(_sunsmart_home_screen_foo);
	
	var _sunsmart_promo_high_uv = __webpack_require__(518);
	
	var _sunsmart_promo_high_uv2 = _interopRequireDefault(_sunsmart_promo_high_uv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SunSmartPage = function SunSmartPage() {
	    return _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-lg-5 project-info' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'UX Case Study: SunSmart 2014'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'project-content' },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'i',
	                            null,
	                            '"Our senses cannot detect UV so it can be damaging without us knowing. There is a huge variation in UV levels across Australia. The UV level is affected by a number of factors including the time of day, time of year, cloud cover, altitude, proximity to the equator, scattering and reflection."'
	                        ),
	                        ' This app makes it easier than ever to be smart about sun exposure all year round.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'SunSmart runs on iPhone, iPad and Android, has had over 100,000 downloads and has thousands of daily users. One year after the first release it was time to not only refresh the SunSmart brand, but to improve key features of the app.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'The initial client meetings resulted in the following tasks:'
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        null,
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            'Refresh of the SunSmart brand'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            'Rethink of the app features e.g. onboarding and home screen'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            'Add new functionality to the sign up & information input screens'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            'Solve the problem of how to capture user information for more accurate sunscreen calculations and to capture demographic and user behavior data for future studies.'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'We started working out the approach we would ideally like to take and then calculated how long we would need to do that work so we could then adjust the methods, tools and techniques to fit the constraints of the project. First, the use of methods like competitor, heuristic and metric analysis gave us the necessary informational foundation for initial sketches and wireframes which eventually resulted in a prototype ready to be tested by users and stakeholders.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'One of the major challenges of that project was the onboarding and home screen experience. Resulting from the research, the richness of information on the home screen felt very overwhelming for the user. However the client was very insistent that all of the information was essential. The weather forecast, high and low temperatures, highest and current UV level, and the highlighted sun screen alert times had to be structured in a way to not stress out the user and fulfill the expectations of the client. We believe the end result captured these requirements.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Further information about the research will be provided upon request.'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-lg-7' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'slider' },
	                    _react2.default.createElement(_reactImageGallery2.default, {
	                        showThumbnails: false,
	                        showFullscreenButton: false,
	                        autoPlay: true,
	                        items: [{ original: _sunsmart_3d2.default }, { original: _onboarding2.default }, { original: _data_entry2.default }, { original: _home_screen_v2.default }, { original: _home_screen_v4.default }, { original: _home_screen_v6.default }, { original: _home_screen_v8.default }, { original: _sunscreen_calculator2.default }, { original: _sunsmart_home_screen_foo2.default }, { original: _sunsmart_promo_high_uv2.default }] })
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    'p',
	                    { className: 'project-blurb' },
	                    'The slides show the finished product, a time schedule and some early sketches of a project taking shape.'
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    { className: 'tags' },
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Contextual observations, interviews and testing'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Analytics'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Diary studies'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Sketching'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Wireframes'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Prototypes'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'footer-info' },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'highlight' },
	                            'Cooperation Partner:'
	                        ),
	                        ' Boosted Human, Cancer Council Victoria and Vic Health'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'highlight' },
	                            'Source:'
	                        ),
	                        ' Boosted Human'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'highlight' },
	                            'Date:'
	                        ),
	                        ' 2014 - Present'
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = SunSmartPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-sunsmart-js-6d88e9735489e47e561f.js